const codeModules = import.meta.glob('/locales/en-US/code.json', {
  eager: true,
});
const pricingModules = import.meta.glob('/locales/en-US/pricing.json', {
  eager: true,
});

function getData(modules: any) {
  if (modules && Object.keys(modules).length) {
    return modules[Object.keys(modules)[0]].default;
  }
  return {};
}

export const codeJson = getData(codeModules);
export const pricingJson = getData(pricingModules);
